

// import React, { useEffect, useState } from "react";
// import {
//   Box, Button, Typography, Grid, TableContainer, Table,
//   TableHead, TableBody, IconButton, MenuItem, Autocomplete,
//   Select, TextField, TableRow, TableCell,
// } from "@mui/material";
// import {
//   Breadcrumb, CTSinput, StyledTableCell, StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DescriptionIcon from "@mui/icons-material/Description";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import supplierMasterService from "../../../services/masters/supplierMaster.Service";
// import grnService from "../../../services/grnService";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantMasterSerivce from "../../../services/masters/plantMaster.Service";
// import rmMasterService from "../../../services/masters/rmMaster.Service";
// import uomMasterService from "../../../services/masters/uomMaster.Service";

// // ── Styles (PlantAdd pattern) ─────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Segoe UI', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",

//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const sectionDividerSx = {
//   fontSize: "11px",
//   fontWeight: 700,
//   color: "#1C3A5E",
//   textTransform: "uppercase",
//   letterSpacing: "0.5px",
//   mb: 1.5,
//   pb: 0.75,
//   borderBottom: "2px solid #E2E8F0",
// };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "block",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     background: "#fafafa",
//     height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
// };

// const datePickerSx = {
//   width: "100%",
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     background: "#fafafa",
//     height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//   },
// };

// const tableCellInputSx = {
//   border: "none",
//   background: "transparent",
//   fontSize: "12px",
//   width: "100%",
//   padding: "2px 4px",
//   outline: "none",
//   color: "#1A202C",
//   fontFamily: "'Segoe UI', Arial, sans-serif",
// };

// const formFooterSx = {
//   padding: "16px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "38px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   borderRadius: "8px",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   "&:hover": { background: "#388E3C" },
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "38px",
//   background: "#E53E3E",
//   color: "#fff",
//   border: "none",
//   borderRadius: "8px",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   "&:hover": { background: "#C53030" },
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const GRNAdd = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const entry_id = editData ? editData.entry_id : null;

//   let navigate = useNavigate();
//   const [isSet, setIsSet] = useState(false);
//   const [total, setTotal] = useState(0);
//   const [total_tax, setTotalTax] = useState(editData ? editData.total_tax : 0);
//   const [gross_total, setGrossTotal] = useState(editData ? editData.gross_total : 0);
//   const [material_chek, setMaterial_chek] = React.useState(false);
//   const [supplier_quotation_date, setSupplier_quotation_date] = useState(new Date());

//   const [certificatefile, setCertificatefile] = useState(editData ? editData.upload_certificate : null);
//   const [uploadinvoice, setUploadinvoice] = useState(editData ? editData.upload_invoice : null);
//   const [upload_challan, setUploadchallan] = useState(editData ? editData.upload_challan : null);
//   const [uploadlr, setUploadlr] = useState(editData ? editData.upload_lr : null);

//   const [data, setData] = useState({
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData?.entry_date
//       ? dayjs(editData.entry_date, "DD/MM/YYYY").format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     delivery_address: editData ? editData.delivery_address : "",
//     invoice_no: editData ? editData.invoice_no : "",
//     challan_no: editData ? editData.challan_no : "",
//     lr_no: editData ? editData.lr_no : "",
//     transporter: editData ? editData.transporter : "",
//     vehicle_no: editData ? editData.vehicle_no : "",
//     driver_name: editData ? editData.driver_name : "",
//     certificate_no: editData ? editData.certificate_no : "",
//     supplier_id: editData ? editData.supplier_id : "",
//     supplier_name: editData ? editData.supplier_name : "",
//     invoice_date: editData?.invoice_date
//       ? dayjs(editData.invoice_date, "DD/MM/YYYY").format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     challan_date: editData?.challan_date
//       ? dayjs(editData.challan_date, "DD/MM/YYYY").format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     fin_year: editData ? editData.fin_year : "",
//     plant_id: editData ? editData.plant_id : userInfo.plant_id,
//     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     modified_by: editData ? userInfo.user_id : null,
//     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     created_by: editData ? editData.created_by : userInfo.user_id,
//   });

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     const updatedData = {
//       ...data,
//       [name]: name === "entry_date" || name === "challan_date"
//         ? dayjs(value).format("YYYY-MM-DD")
//         : value,
//     };
//     if (name === "entry_date") {
//       const selectedDate = new Date(value);
//       const month = selectedDate.getMonth();
//       const year = selectedDate.getFullYear();
//       const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
//       updatedData.fin_year = financialYear;
//     }
//     setData(updatedData);
//   };

//   const handleChangeCheck = (event) => {
//     setMaterial_chek(event.target.checked);
//   };

//   const [driver, setDriver] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [plant, setPlant] = useState([]);
//   const [Rm, setRm] = useState([]);
//   const [uom, setuom] = useState([]);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [driverData, supplierData, plantData, rmData, uomData] = await Promise.all([
//           driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//           supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
//           plantMasterSerivce.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           rmMasterService.getRMList({ page: 0, size: 999, searchKey: "" }),
//           uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setDriver(driverData);
//         setSupplier(supplierData);
//         setPlant(plantData);
//         setRm(rmData);
//         setuom(uomData);
//       } catch (error) {
//         console.error("Data fetching failed", error);
//       }
//     }
//     fetchData();
//   }, []);

//   const uploadFile = (e) => { setCertificatefile(e.target.files[0]); };
//   const uploadInvoiceFile = (e) => { setUploadinvoice(e.target.files[0]); };
//   const uploadChallanFile = (e) => { setUploadchallan(e.target.files[0]); };
//   const uploadLRFile = (e) => { setUploadlr(e.target.files[0]); };

//   const certificateSrc = certificatefile && certificatefile instanceof File ? URL.createObjectURL(certificatefile) : certificatefile;
//   const invoiceSrc = uploadinvoice && uploadinvoice instanceof File ? URL.createObjectURL(uploadinvoice) : uploadinvoice;
//   const challanSrc = upload_challan && upload_challan instanceof File ? URL.createObjectURL(upload_challan) : upload_challan;
//   const lrSrc = uploadlr && uploadlr instanceof File ? URL.createObjectURL(uploadlr) : uploadlr;

//   useEffect(() => {
//     let objectUrlPo, objectUrlQuotation, objectUrlChallan, objectUrlLR;
//     if (certificatefile instanceof File) objectUrlPo = URL.createObjectURL(certificatefile);
//     if (uploadinvoice instanceof File) objectUrlQuotation = URL.createObjectURL(uploadinvoice);
//     if (upload_challan instanceof File) objectUrlChallan = URL.createObjectURL(upload_challan);
//     if (uploadlr instanceof File) objectUrlLR = URL.createObjectURL(uploadlr);
//     return () => {
//       if (objectUrlPo) URL.revokeObjectURL(objectUrlPo);
//       if (objectUrlQuotation) URL.revokeObjectURL(objectUrlQuotation);
//       if (objectUrlChallan) URL.revokeObjectURL(objectUrlChallan);
//       if (objectUrlLR) URL.revokeObjectURL(objectUrlLR);
//     };
//   }, [certificatefile, uploadinvoice, upload_challan, uploadlr]);

//   const onSubmit = async (event) => {
//     const GrnData = {
//       ...data,
//       entry_id: entry_id,
//       grn_details: JSON.stringify(grn_details),
//       changedUpdatedValue: "edit",
//       depot_id: depot_id,
//       short_code: short_code,
//       unit_id: unit_id,
//       plant_id: data.plant_id,
//     };
//     const formData = new FormData();
//     formData.append("grnData", JSON.stringify(GrnData));
//     if (certificatefile) formData.append("upload_certificate", certificatefile);
//     if (uploadinvoice) formData.append("upload_invoice", uploadinvoice);
//     if (upload_challan) formData.append("upload_challan", upload_challan);
//     if (uploadlr) formData.append("upload_lr", uploadlr);
//     try {
//       if (editData) {
//         await grnService.editDeleteGrn(formData);
//       } else {
//         await grnService.addGrn(formData);
//       }
//       setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
//       setTimeout(() => navigate(-1), 1000);
//     } catch (error) {
//       setSuccessMessage("Error occurred");
//     }
//   };

//   const [isUpdateArray, setIsUpdateArray] = useState(false);
//   const [grn_details, setGrn_details] = useState(
//     editData ? JSON.parse(editData.grn_details) : [{
//       sr_no: "", po_no_date: "", matrial_code: "", item_description: "",
//       dept_unit: "", uom: "", challan_qty: 0, recived_qty: 0, short_qty: 0,
//       excess_qty: 0, rejected_qty: 0, accepted_qty: 0, unit_rate: 0,
//     }]
//   );

//   const handleChangeInput = (e, i) => {
//     const array = [...grn_details];
//     let result = array[i];
//     result[e.target.name] = e.target.value;
//     result.sr_no = i + 1;
//     array[i] = result;
//     setGrn_details(array);
//     setIsUpdateArray(!isUpdateArray);

//     let tltAmt = result["total"] ? result["total"] : 0;
//     let qty = result["quantity"] ? result["quantity"] : 0;
//     let rate = result["unit_price"] ? result["unit_price"] : 0;
//     let gst = result["tax_code"] ? result["tax_code"] : 0;
//     let challan_qty = result["challan_qty"] ? result["challan_qty"] : 0;
//     let recived_qty = result["recived_qty"] ? result["recived_qty"] : 0;
//     let accepted_qty = result["accepted_qty"] ? result["accepted_qty"] : 0;

//     if (e.target.name == "quantity") qty = parseFloat(e.target.value);
//     if (e.target.name == "unit_price") rate = parseFloat(e.target.value);
//     if (e.target.name == "tax_code") gst = parseFloat(e.target.value);
//     if (e.target.name == "challan_qty") challan_qty = parseFloat(e.target.value);
//     if (e.target.name == "recived_qty") recived_qty = parseFloat(e.target.value);
//     if (e.target.name == "accepted_qty") accepted_qty = parseFloat(e.target.value);

//     let basicAmt = parseFloat(qty) * parseFloat(rate);
//     let gstAmt = (parseFloat(basicAmt) * parseFloat(gst)) / 100;
//     let shortQty = parseFloat(challan_qty) - parseFloat(recived_qty);
//     let rejectQty = parseFloat(recived_qty) - parseFloat(accepted_qty);
//     tltAmt = parseFloat(basicAmt) + parseFloat(gstAmt);
//     result["total"] = parseFloat(basicAmt);
//     result["tax_amount"] = parseFloat(gstAmt);
//     result["amount"] = parseFloat(tltAmt);
//     result["short_qty"] = parseFloat(shortQty);
//     result["rejected_qty"] = parseFloat(rejectQty);
//     array[i] = result;

//     const reducer = (previousValue, currentValue) => previousValue + currentValue;
//     const totalCount = grn_details && grn_details.map((v) => v.total && v.total ? parseFloat(v.total) : 0).reduce(reducer);
//     setTotal(totalCount);
//     const gstamount = grn_details && grn_details.map((v) => v.tax_amount && v.tax_amount ? parseFloat(v.tax_amount) : 0).reduce(reducer);
//     const totalamount = grn_details && grn_details.map((v) => v.amount && v.amount ? parseFloat(v.amount) : 0).reduce(reducer);
//     setTotalTax(gstamount);
//     setGrossTotal(totalamount);
//     setIsSet(isSet ? false : true);
//   };

//   const handleRemoveGrn = (index) => {
//     const values = [...grn_details];
//     values.splice(index, 1);
//     setGrn_details(values);
//     setIsUpdateArray(isUpdateArray ? false : true);
//     const reducer = (previousValue, currentValue) => previousValue + currentValue;
//     const totalCount = values && values.map((v) => v.total && v.total ? parseFloat(v.total) : 0).reduce(reducer);
//     const gstTotalCount = values && values.map((v) => v.tax_amount && v.tax_amount ? parseFloat(v.tax_amount) : 0).reduce(reducer);
//     const amountTotalCount = values && values.map((v) => v.amount && v.amount ? parseFloat(v.amount) : 0).reduce(reducer);
//     setTotal(totalCount);
//     setTotalTax(gstTotalCount);
//     setGrossTotal(amountTotalCount);
//   };

//   const handleAddSPQuotationFields = () => {
//     setGrn_details([...grn_details, {
//       sr_no: grn_details.length + 1, po_no_date: "", matrial_code: "",
//       dept_unit: "", uom: "", challan_qty: 0, recived_qty: 0, short_qty: 0,
//       excess_qty: 0, rejected_qty: 0, accepted_qty: 0, unit_rate: 0,
//       discount: 0, amount: 0,
//     }]);
//   };

//   const [successMessage, setSuccessMessage] = useState(null);

//   const getMaterialName = (materialCode) => {
//     const material = Rm.find((item) => item.rm_id === materialCode);
//     return material ? material.rm_name : "Unknown Material";
//   };

//   // ── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Snackbar */}
//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage("")}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />

//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           Dashboard / Entries /{" "}
//           <span style={{ color: "#2B6CB0", fontWeight: 600 }}>GRN / Material Entry</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <DescriptionIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} GRN / MATERIAL ENTRY
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         {/* Main Card */}
//         <Box sx={formCardSx}>

//           {/* Navy Header */}
//           <Box sx={sectionHeaderSx}>
//             <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
//             <Typography sx={sectionTitleSx}>GRN / Material Entry Details</Typography>
//           </Box>

//           <form onSubmit={handleSubmit(onSubmit)}>
//             <Box sx={formBodySx}>

              

//               <Grid container spacing={2} sx={{ mb: 3 }}>

//                 {/* Supplier Name */}
//                 <Grid item xs={12} md={6}>
//                   <Typography sx={fieldLabelSx}>Supplier Name</Typography>
//                   <Autocomplete
//                     options={supplier || []}
//                     getOptionLabel={(option) => option.supplier_name || ""}
//                     value={supplier.find((s) => s.supplier_id === data.supplier_id) || null}
//                     onChange={(e, newValue) => {
//                       setData({
//                         ...data,
//                         supplier_id: newValue ? newValue.supplier_id : "",
//                         supplier_name: newValue ? newValue.supplier_name : "",
//                       });
//                     }}
//                     renderOption={(props, option) => (
//                       <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.supplier_name}</MenuItem>
//                     )}
//                     renderInput={(params) => (
//                       <TextField {...params} size="small" fullWidth placeholder="Select supplier" sx={inputSx} />
//                     )}
//                   />
//                 </Grid>

//                 {/* Plant */}
//                 <Grid item xs={12} md={6}>
//                   <Typography sx={fieldLabelSx}>Plant</Typography>
//                   <Autocomplete
//                     options={plant || []}
//                     getOptionLabel={(option) => option.plant_name || ""}
//                     value={plant.find((p) => p.plant_id === data.plant_id) || null}
//                     onChange={(e, newValue) => {
//                       setData({ ...data, plant_id: newValue ? newValue.plant_id : "" });
//                     }}
//                     renderOption={(props, option) => (
//                       <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.plant_name}</MenuItem>
//                     )}
//                     renderInput={(params) => (
//                       <TextField {...params} size="small" fullWidth placeholder="Select plant" sx={inputSx} />
//                     )}
//                   />
//                 </Grid>

//                   <Grid item xs={7} sm={5}>
//                                       <Typography sx={fieldLabelSx}>Entry No</Typography>
//                                       <TextField
//                                         size="small" fullWidth name="entry_no"
//                                         value={data.entry_no}
                                       
//                                         InputProps={{ readOnly: true }}
//                                         placeholder="Auto-generated"
//                                       />
//                                     </Grid>

//                 {/* Entry Date */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Entry Date</Typography>
//                   <DatePicker
//                     format="DD/MM/YYYY"
//                     value={dayjs(data.entry_date)}
//                     onChange={(val) => handleChange({ target: { name: "entry_date", value: val?.format("YYYY-MM-DD") } })}
//                     slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
//                   />
//                 </Grid>

//                 {/* Invoice No */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Invoice No</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="invoice_no" value={data.invoice_no}
//                     onChange={handleChange}
//                     placeholder="Enter invoice no"
//                     sx={inputSx}
//                   />
//                 </Grid>

//                 {/* Invoice Date */}
//                 {/* <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Invoice Date</Typography>
//                   <DatePicker
//                     format="DD/MM/YYYY"
//                     value={dayjs(data.invoice_date)}
//                     onChange={(val) => handleChange({ target: { name: "invoice_date", value: val?.format("YYYY-MM-DD") } })}
//                     slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
//                   />
//                 </Grid> */}

//                 {/* Challan No */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Challan No</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="challan_no" value={data.challan_no}
//                     onChange={handleChange}
//                     placeholder="Enter challan no"
//                     sx={inputSx}
//                   />
//                 </Grid>

//                 {/* Challan Date */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Challan Date</Typography>
//                   <DatePicker
//                     format="DD/MM/YYYY"
//                     value={dayjs(data.challan_date)}
//                     onChange={(val) => handleChange({ target: { name: "challan_date", value: val?.format("YYYY-MM-DD") } })}
//                     slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
//                   />
//                 </Grid>

//                 {/* LR No */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>LR No</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="lr_no" value={data.lr_no}
//                     onChange={handleChange}
//                     placeholder="Enter LR no"
//                     sx={inputSx}
//                   />
//                 </Grid>

//                 {/* Transporter */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Transporter</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="transporter" value={data.transporter}
//                     onChange={handleChange}
//                     placeholder="Enter transporter"
//                     sx={inputSx}
//                   />
//                 </Grid>

//                 {/* Vehicle No */}
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Vehicle No</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="vehicle_no" value={data.vehicle_no}
//                     onChange={handleChange}
//                     placeholder="Enter vehicle no"
//                     sx={inputSx}
//                   />
//                 </Grid>

                
//                 {/* <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Driver Name</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="driver_name" value={data.driver_name}
//                     onChange={handleChange}
//                     placeholder="Enter driver name"
//                     sx={inputSx}
//                   />
//                 </Grid> */}

//                 {/* Certificate No */}
//                 {/* <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Certificate No</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="certificate_no" value={data.certificate_no}
//                     onChange={handleChange}
//                     placeholder="Enter certificate no"
//                     sx={inputSx}
//                   />
//                 </Grid> */}

//                 {/* Delivery Address */}
//                 {/* <Grid item xs={12} md={6}>
//                   <Typography sx={fieldLabelSx}>Delivery Address</Typography>
//                   <TextField
//                     size="small" fullWidth
//                     name="delivery_address" value={data.delivery_address}
//                     onChange={handleChange}
//                     placeholder="Enter delivery address"
//                     sx={inputSx}
//                   />
//                 </Grid> */}

//               </Grid>

            

//               <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
//                 <TableContainer>
//                   <Table size="small" sx={{ minWidth: 800 }}>
//                     <TableHead>
//                       <TableRow>
//                         {["Sr No", "Material", "UOM", "Challan Qty", "Received Qty", "Short Qty", "Accepted Qty", "Rejected Qty", "Action"].map((h) => (
//                           <TableCell
//                             key={h}
//                             sx={{
//                               background: "#1C3A5E", color: "#fff",
//                               fontSize: "11px", fontWeight: 600,
//                               whiteSpace: "nowrap", borderBottom: "none",
//                               padding: "10px 10px",
//                             }}
//                           >
//                             {h}
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {grn_details.map((row, index) => (
//                         <TableRow
//                           key={index}
//                           sx={{
//                             background: index % 2 === 0 ? "#fff" : "#F8FAFC",
//                             "&:hover": { background: "#EBF4FF" },
//                             "& td": { borderBottom: "1px solid #E2E8F0", padding: "6px 8px" },
//                           }}
//                         >
//                           <TableCell sx={{ color: "#555", fontWeight: 600, fontSize: "12px", width: 50 }}>
//                             {index + 1}
//                           </TableCell>

//                           {/* Material dropdown */}
//                           <TableCell sx={{ minWidth: 150 }}>
//                             <CTSinput
//                               select
//                               value={row.matrial_code}
//                               name="matrial_code"
//                               onChange={(e) => handleChangeInput(e, index)}
//                               InputProps={{ disableUnderline: true, sx: { fontSize: "12px" } }}
//                               variant="standard"
//                               fullWidth
//                             >
//                               {Rm.map((c) => (
//                                 <MenuItem key={c.rm_id} value={c.rm_name} sx={{ fontSize: "13px" }}>
//                                   {c.rm_name}
//                                 </MenuItem>
//                               ))}
//                             </CTSinput>
//                           </TableCell>

//                           {/* UOM dropdown */}
//                           <TableCell sx={{ minWidth: 90 }}>
//                             <Select
//                               fullWidth
//                               variant="standard"
//                               disableUnderline
//                               value={row.uom}
//                               name="uom"
//                               onChange={(e) => handleChangeInput(e, index)}
//                               sx={{ fontSize: "12px" }}
//                             >
//                               <MenuItem value="" sx={{ fontSize: "13px" }}>Select</MenuItem>
//                               <MenuItem value="KGS" sx={{ fontSize: "13px" }}>KGS</MenuItem>
//                             </Select>
//                           </TableCell>

//                           {/* Qty fields */}
//                           {["challan_qty", "recived_qty", "short_qty", "accepted_qty", "rejected_qty"].map((field) => (
//                             <TableCell key={field}>
//                               <input
//                                 style={tableCellInputSx}
//                                 name={field}
//                                 value={row[field]}
//                                 onChange={(e) => handleChangeInput(e, index)}
//                                 placeholder="0"
//                               />
//                             </TableCell>
//                           ))}

//                           {/* Action */}
//                           <TableCell align="center" sx={{ width: 80 }}>
//                             <Box sx={{ display: "flex", gap: "2px", justifyContent: "center" }}>
//                               <IconButton size="small" onClick={handleAddSPQuotationFields}
//                                 sx={{ border: "1px solid #1b52d1", borderRadius: "50%", width: 22, height: 22, color: "#1b52d1" }}>
//                                 <AddIcon sx={{ fontSize: 14 }} />
//                               </IconButton>
//                               {index !== 0 && (
//                                 <IconButton size="small" onClick={() => handleRemoveGrn(index)}
//                                   sx={{ color: "#E53E3E" }}>
//                                   <DeleteForeverIcon sx={{ fontSize: 18 }} />
//                                 </IconButton>
//                               )}
//                             </Box>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Box>

//             </Box>

//             {/* Footer Buttons */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>
//                 Cancel
//               </Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 17 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </form>
//         </Box>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default GRNAdd;



import React, { useEffect, useState, useRef } from "react";
import {
  Box, Button, Typography, Grid, TableContainer, Table,
  TableHead, TableBody, IconButton, MenuItem, Autocomplete,
  Select, TextField, TableRow, TableCell,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionIcon from "@mui/icons-material/Description";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import driverMasterService from "../../../services/masters/driverMaster.Service";
import supplierMasterService from "../../../services/masters/supplierMaster.Service";
import grnService from "../../../services/grnService";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import plantMasterSerivce from "../../../services/masters/plantMaster.Service";
import rmMasterService from "../../../services/masters/rmMaster.Service";
import uomMasterService from "../../../services/masters/uomMaster.Service";
import { CTSinput } from "../../reusableComponent/Reusables";

// ── Styles ────────────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const datePickerSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
  },
};

const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

const tableCellInputSx = {
  border: "none",
  background: "transparent",
  fontSize: "12px",
  width: "100%",
  padding: "2px 4px",
  outline: "none",
  color: "#1A202C",
  fontFamily: "'Inter', Arial, sans-serif",
};

const formFooterSx = {
  padding: "16px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#C53030" },
};

// ─────────────────────────────────────────────────────────────────────────────

const GRNAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const depot_id = userInfo.depot_id;
  const plant_id = userInfo.plant_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const entry_id = editData ? editData.entry_id : null;

  let navigate = useNavigate();
  const [total, setTotal] = useState(0);
  const [total_tax, setTotalTax] = useState(editData ? editData.total_tax : 0);
  const [gross_total, setGrossTotal] = useState(editData ? editData.gross_total : 0);

  const [certificatefile, setCertificatefile] = useState(editData ? editData.upload_certificate : null);
  const [uploadinvoice, setUploadinvoice] = useState(editData ? editData.upload_invoice : null);
  const [upload_challan, setUploadchallan] = useState(editData ? editData.upload_challan : null);
  const [uploadlr, setUploadlr] = useState(editData ? editData.upload_lr : null);

  const [data, setData] = useState({
    entry_no: editData ? editData.entry_no : "",
    entry_date: editData?.entry_date
      ? dayjs(editData.entry_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    delivery_address: editData ? editData.delivery_address : "",
    invoice_no: editData ? editData.invoice_no : "",
    challan_no: editData ? editData.challan_no : "",
    lr_no: editData ? editData.lr_no : "",
    transporter: editData ? editData.transporter : "",
    vehicle_no: editData ? editData.vehicle_no : "",
    driver_name: editData ? editData.driver_name : "",
    certificate_no: editData ? editData.certificate_no : "",
    supplier_id: editData ? editData.supplier_id : "",
    supplier_name: editData ? editData.supplier_name : "",
    invoice_date: editData?.invoice_date
      ? dayjs(editData.invoice_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    challan_date: editData?.challan_date
      ? dayjs(editData.challan_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    fin_year: editData ? editData.fin_year : "",
    plant_id: editData ? editData.plant_id : userInfo.plant_id,
    modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    modified_by: editData ? userInfo.user_id : null,
    created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: editData ? editData.created_by : userInfo.user_id,
  });

  const handleChange = ({ target }) => {
    const { name, value } = target;
    const updatedData = {
      ...data,
      [name]: name === "entry_date" || name === "challan_date"
        ? dayjs(value).format("YYYY-MM-DD")
        : value,
    };
    if (name === "entry_date") {
      const selectedDate = new Date(value);
      const month = selectedDate.getMonth();
      const year = selectedDate.getFullYear();
      const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
      updatedData.fin_year = financialYear;
    }
    setData(updatedData);
  };

  const [driver, setDriver] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [plant, setPlant] = useState([]);
  const [Rm, setRm] = useState([]);
  const [uom, setuom] = useState([]);
  const [grnMap, setGrnMap] = useState([]);

useEffect(() => {
    async function fetchData() {
      try {
        const [driverData, supplierData, plantData, rmData, uomData] = await Promise.all([
          driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
          plantMasterSerivce.getPlantList({ page: 0, size: 999, searchKey: "" }),
          rmMasterService.getRMList({ page: 0, size: 999, searchKey: "" }),
          uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
        ]);
        setDriver(driverData);
        setSupplier(supplierData);
        setPlant(plantData);
        setRm(rmData);
        setuom(uomData);

        // ✅ Generate entry_no for ADD mode only
        if (!editData) {
          const grnList = await grnService.getGrnList({ page: 0, size: 5, searchKey: "" });
          
          // picks "GRN/SP/26-27/0008" → last part = "0008"
          const lastEntryNo = grnList?.[0]?.entry_no ?? "";
          const parts = String(lastEntryNo).split("/");
          const lastSeq = parseInt(parts[parts.length - 1]) || 0;
          const nextSeq = lastSeq + 1;

          // ✅ Short year format: "26-27" not "2026-27"
          const yr = dayjs();
          const finYear = yr.month() >= 3
            ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
            : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

          const formattedEntryNo = `GRN/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

          setData(prev => ({
            ...prev,
            entry_no: formattedEntryNo,
            fin_year: finYear,
          }));
        }

      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }
    fetchData();
  }, []);

const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const onSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    const GrnData = {
      ...data,
      entry_id: entry_id,
      grn_details: JSON.stringify(grn_details),
      changedUpdatedValue: "edit",
      depot_id: depot_id,
      short_code: short_code,
      unit_id: unit_id,
      plant_id: data.plant_id,
    };
    const formData = new FormData();
    formData.append("grnData", JSON.stringify(GrnData));
    if (certificatefile) formData.append("upload_certificate", certificatefile);
    if (uploadinvoice) formData.append("upload_invoice", uploadinvoice);
    if (upload_challan) formData.append("upload_challan", upload_challan);
    if (uploadlr) formData.append("upload_lr", uploadlr);
      try {
      if (editData) {
        await grnService.editDeleteGrn(formData);
      } else {
        await grnService.addGrn(formData);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      // success case mein reset NAHI karna — navigate hone tak button disabled hi rahega
    } catch (error) {
      setSuccessMessage("Error occurred");
      isSubmittingRef.current = false;
      setIsSubmitting(false);   // sirf error par retry allow karo
    }
  };
  const [isUpdateArray, setIsUpdateArray] = useState(false);
  const [grn_details, setGrn_details] = useState(
    editData ? JSON.parse(editData.grn_details) : [{
      sr_no: 1,
      po_no_date: "",
      matrial_code: "",
      item_description: "",
      dept_unit: "",
     uom: "KGS",
      accepted_qty: 0,
      unit_rate: 0,
      discount: 0,
      amount: 0,
    }]
  );

  const handleChangeInput = (e, i) => {
    const array = [...grn_details];
    let result = { ...array[i] };
    result[e.target.name] = e.target.value;
    result.sr_no = i + 1;

    const qty = parseFloat(result["accepted_qty"]) || 0;
    const rate = parseFloat(result["unit_rate"]) || 0;
    const gst = parseFloat(result["tax_code"]) || 0;
    const basicAmt = qty * rate;
    const gstAmt = (basicAmt * gst) / 100;
    result["total"] = basicAmt;
    result["tax_amount"] = gstAmt;
    result["amount"] = basicAmt + gstAmt;

    array[i] = result;
    setGrn_details(array);
    setIsUpdateArray(!isUpdateArray);

    const reducer = (a, b) => a + b;
    const totalCount = array.map((v) => parseFloat(v.total) || 0).reduce(reducer, 0);
    const gstAmount = array.map((v) => parseFloat(v.tax_amount) || 0).reduce(reducer, 0);
    const totalAmount = array.map((v) => parseFloat(v.amount) || 0).reduce(reducer, 0);
    setTotal(totalCount);
    setTotalTax(gstAmount);
    setGrossTotal(totalAmount);
  };

  const handleRemoveGrn = (index) => {
    const values = [...grn_details];
    values.splice(index, 1);
    setGrn_details(values);
    setIsUpdateArray(!isUpdateArray);
    const reducer = (a, b) => a + b;
    setTotal(values.map((v) => parseFloat(v.total) || 0).reduce(reducer, 0));
    setTotalTax(values.map((v) => parseFloat(v.tax_amount) || 0).reduce(reducer, 0));
    setGrossTotal(values.map((v) => parseFloat(v.amount) || 0).reduce(reducer, 0));
  };

  const handleAddRow = () => {
    setGrn_details([...grn_details, {
      sr_no: grn_details.length + 1,
      po_no_date: "",
      matrial_code: "",
      item_description: "",
      dept_unit: "",
    uom: "KGS",
      accepted_qty: 0,
      unit_rate: 0,
      discount: 0,
      amount: 0,
    }]);
  };

  const [successMessage, setSuccessMessage] = useState(null);

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Snackbar */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage("")}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          Dashboard / Entries /{" "}
          <span style={{ color: "#2B6CB0", fontWeight: 600 }}>GRN / Material Receipts</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <DescriptionIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} GRN / MATERIAL RECEIPTS
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ── GRN Details Card ─────────────────────────────────────── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionTitleSx}>GRN / MATERIAL RECEIPT DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              {/* Two-column layout matching CylinderInward pattern */}
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* ════ LEFT COLUMN — Supplier & Document Info ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{
                    p: 2.5,
                   
                    borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
                  }}
                >
                  <Grid container spacing={1.5}>

                    {/* Supplier Name */}
                    <Grid item xs={12} sm={10}>
                      <Typography sx={fieldLabelSx}>
                        Supplier Name <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={supplier || []}
                        getOptionLabel={(option) => option.supplier_name || ""}
                        value={supplier.find((s) => s.supplier_id === data.supplier_id) || null}
                        onChange={(e, newValue) => {
                          setData({
                            ...data,
                            supplier_id: newValue ? newValue.supplier_id : "",
                            supplier_name: newValue ? newValue.supplier_name : "",
                          });
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={menuItemSx}>{option.supplier_name}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth placeholder="Select supplier" sx={inputSx} />
                        )}
                      />
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Transporter</Typography>
                      <TextField
                        size="small" fullWidth
                        name="transporter" value={data.transporter}
                        onChange={handleChange}
                        placeholder="Enter transporter"
                        sx={inputSx}
                      />
                    </Grid>

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Vehicle No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="vehicle_no" value={data.vehicle_no}
                        onChange={handleChange}
                        placeholder="Enter vehicle no"
                        sx={inputSx}
                      />
                    </Grid>

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>LR No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="lr_no" value={data.lr_no}
                        onChange={handleChange}
                        placeholder="Enter LR no"
                        sx={inputSx}
                      />
                    </Grid>

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Driver Name</Typography>
                      <TextField
                        size="small" fullWidth
                        name="driver_name" value={data.driver_name}
                        onChange={handleChange}
                        placeholder="Enter driver name"
                        sx={inputSx}
                      />
                    </Grid>


                    {/* Plant */}
                    {/* <Grid item xs={12} sm={10}>
                      <Typography sx={fieldLabelSx}>Plant</Typography>
                      <Autocomplete
                        options={plant || []}
                        getOptionLabel={(option) => option.plant_name || ""}
                        value={plant.find((p) => p.plant_id === data.plant_id) || null}
                        onChange={(e, newValue) => {
                          setData({ ...data, plant_id: newValue ? newValue.plant_id : "" });
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={menuItemSx}>{option.plant_name}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth placeholder="Select plant" sx={inputSx} />
                        )}
                      />
                    </Grid> */}

                    {/* Invoice No */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Invoice No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="invoice_no" value={data.invoice_no}
                        onChange={handleChange}
                        placeholder="Enter invoice no"
                        sx={inputSx}
                      />
                    </Grid> */}

                    {/* Challan No */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Challan No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="challan_no" value={data.challan_no}
                        onChange={handleChange}
                        placeholder="Enter challan no"
                        sx={inputSx}
                      />
                    </Grid> */}

                    {/* Challan Date */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Challan Date</Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.challan_date)}
                        onChange={(val) => handleChange({ target: { name: "challan_date", value: val?.format("YYYY-MM-DD") } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
                      />
                    </Grid> */}

                    {/* LR No */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>LR No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="lr_no" value={data.lr_no}
                        onChange={handleChange}
                        placeholder="Enter LR no"
                        sx={inputSx}
                      />
                    </Grid> */}

                  </Grid>
                </Grid>

                {/* ════ RIGHT COLUMN — Entry & Transport Info ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}
                >
                  <Grid container spacing={1.5}>

                    {/* Entry No — auto-filled */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="entry_no"
                        value={data.entry_no}
                        InputProps={{ readOnly: true }}
                        placeholder="Auto-generated"
                        sx={readonlyInputSx}
                      />
                    </Grid>

                    {/* Entry Date */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Entry Date <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.entry_date)}
                        onChange={(val) => handleChange({ target: { name: "entry_date", value: val?.format("YYYY-MM-DD") } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: datePickerSx } }}
                      />
                    </Grid>

                       <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Challan No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="challan_no" value={data.challan_no}
                        onChange={handleChange}
                        placeholder="Enter challan no"
                        sx={inputSx}
                      />
                    </Grid>

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Challan Date</Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.challan_date)}
                        onChange={(val) => handleChange({ target: { name: "challan_date", value: val?.format("YYYY-MM-DD") } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
                      />
                    </Grid>

                    {/* Transporter */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Transporter</Typography>
                      <TextField
                        size="small" fullWidth
                        name="transporter" value={data.transporter}
                        onChange={handleChange}
                        placeholder="Enter transporter"
                        sx={inputSx}
                      />
                    </Grid> */}

                    {/* Vehicle No */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Vehicle No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="vehicle_no" value={data.vehicle_no}
                        onChange={handleChange}
                        placeholder="Enter vehicle no"
                        sx={inputSx}
                      />
                    </Grid> */}

                     {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>LR No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="lr_no" value={data.lr_no}
                        onChange={handleChange}
                        placeholder="Enter LR no"
                        sx={inputSx}
                      />
                    </Grid> */}

                    {/* Driver Name */}
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Driver Name</Typography>
                      <TextField
                        size="small" fullWidth
                        name="driver_name" value={data.driver_name}
                        onChange={handleChange}
                        placeholder="Enter driver name"
                        sx={inputSx}
                      />
                    </Grid> */}

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ── Material Details Table Card ───────────────────────────── */}
          <Box sx={formCardSx}>
            {/* <Box sx={sectionHeaderSx}>
              <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionTitleSx}>MATERIAL DETAILS</Typography>
            </Box> */}

            <Box sx={{ overflowX: "auto" }}>
              <Table size="small" sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow>
                    {[
                      "Sr No",
                      "Material",
                      // "UOM",
                      "Qty (Kg)",
                      "Unit Rate",
                      "Amount",
                      "Action",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{
                          background: "#1C3A5E",
                          color: "#fff",
                          fontSize: "11px",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                          borderBottom: "none",
                          padding: "10px 12px",
                          fontFamily: "'Inter', Arial, sans-serif",
                        }}
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {grn_details.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        background: index % 2 === 0 ? "#fff" : "#F8FAFC",
                        "&:hover": { background: "#EBF4FF" },
                        "& td": { borderBottom: "1px solid #E2E8F0", padding: "6px 10px" },
                      }}
                    >
                      {/* Sr No */}
                      <TableCell sx={{ color: "#555", fontWeight: 600, fontSize: "12px", width: 50 }}>
                        {index + 1}
                      </TableCell>

                      {/* Material dropdown */}
                      <TableCell sx={{ 
  minWidth: 170,
  "& .MuiInput-root": { border: "none" },
  "& fieldset": { border: "none" },
}}>
  <CTSinput
    select
    value={row.matrial_code}
    name="matrial_code"
    onChange={(e) => handleChangeInput(e, index)}
    InputProps={{ 
      disableUnderline: true, 
      sx: { 
        fontSize: "12px", 
        textTransform: "uppercase",
        border: "none",        // ← ADD
        outline: "none",       // ← ADD
      } 
    }}
    variant="standard"
    fullWidth
    sx={{
      "& .MuiInput-root": { 
        fontSize: "12px",
        border: "none",        // ← ADD
        "&:before": { borderBottom: "none !important" },
        "&:after": { borderBottom: "none !important" },
        "&:hover:not(.Mui-disabled):before": { borderBottom: "none !important" },
      },
    }}
  >
   {Rm.filter((c) => c.rm_name === row.matrial_code || !grn_details.some((r, ri) => ri !== index && r.matrial_code === c.rm_name)).map((c) => (
      <MenuItem key={c.rm_id} value={c.rm_name} sx={{ fontSize: "12px", textTransform: "uppercase" }}>
        {c.rm_name}
      </MenuItem>
    ))}
  </CTSinput>
</TableCell>

                      {/* UOM dropdown */}
                 {/* UOM - fixed to KGS */}
                      {/* <TableCell sx={{ minWidth: 90, fontSize: "12px" }}>
                        KGS
                      </TableCell> */}

                      {/* Accepted Qty */}
                      <TableCell sx={{ minWidth: 110 }}>
                        <input
                          style={tableCellInputSx}
                          name="accepted_qty"
                          value={row.accepted_qty}
                          onChange={(e) => handleChangeInput(e, index)}
                          placeholder="0"
                          type="number"
                          min="0"
                        />
                      </TableCell>

                      {/* Unit Rate */}
                      <TableCell sx={{ minWidth: 100 }}>
                        <input
                          style={tableCellInputSx}
                          name="unit_rate"
                          value={row.unit_rate}
                          onChange={(e) => handleChangeInput(e, index)}
                          placeholder="0.00"
                          type="number"
                          min="0"
                        />
                      </TableCell>

                      {/* Amount (computed) */}
                      <TableCell sx={{ minWidth: 100 }}>
                        <input
                          style={{ ...tableCellInputSx, color: "#2B6CB0", fontWeight: 600 }}
                          name="amount"
                          value={row.amount ? parseFloat(row.amount).toFixed(2) : "0.00"}
                          readOnly
                          placeholder="0.00"
                        />
                      </TableCell>

                      {/* Action */}
                      <TableCell align="center" sx={{ width: 80 }}>
                        <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                          <IconButton
                            size="small"
                            onClick={handleAddRow}
                            sx={{
                              border: "1px solid #1b52d1",
                              borderRadius: "50%",
                              width: 24,
                              height: 24,
                              color: "#1b52d1",
                            }}
                          >
                            <AddIcon sx={{ fontSize: 14 }} />
                          </IconButton>
                          {index !== 0 && (
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveGrn(index)}
                              sx={{ color: "#E53E3E" }}
                            >
                              <DeleteForeverIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

            {/* Totals row */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 4,
                px: 3,
                py: 1.5,
                background: "#F0F4F8",
                borderTop: "1px solid #E2E8F0",
                fontSize: "12px",
                fontFamily: "'Inter', Arial, sans-serif",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 600 }}>Basic Total:</Typography>
                <Typography sx={{ fontSize: "13px", color: "#1C3A5E", fontWeight: 700 }}>
                  ₹ {parseFloat(total).toFixed(2)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 600 }}>Tax Total:</Typography>
                <Typography sx={{ fontSize: "13px", color: "#1C3A5E", fontWeight: 700 }}>
                  ₹ {parseFloat(total_tax).toFixed(2)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 600 }}>Gross Total:</Typography>
                <Typography sx={{ fontSize: "14px", color: "#2B6CB0", fontWeight: 800 }}>
                  ₹ {parseFloat(gross_total).toFixed(2)}
                </Typography>
              </Box>
            </Box>

            {/* Footer Buttons */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>
                Cancel
              </Button>
             <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 17 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>

        </form>
      </Box>
    </LocalizationProvider>
  );
};

export default GRNAdd;